export const sliderIcon = [
  "24 24",
  `
    <path xmlns="http://www.w3.org/2000/svg" fill="none" stroke="" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M4,21v-7 M4,10V3 M12,21v-9
	 M12,8V3 M20,21v-5 M20,12V3 M1,14h6 M9,8h6 M17,16h6"/>
    `,
];
